<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name">
        <span slot="label">
          <a-tooltip>供应商名称<template slot="title">供应商名称</template></a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="32" :placeholder="$t('请输入')+'供应商名称'"/>
      </a-form-model-item>
      <a-form-model-item prop="mobile">
        <span slot="label">
          <a-tooltip>供应商手机号<template slot="title">供应商手机号</template></a-tooltip>
        </span>
        <a-input v-model="form.mobile" :maxLength="32" :placeholder="$t('请输入')+'供应商手机号'"/>
      </a-form-model-item>
      <a-form-model-item prop="email">
        <span slot="label">
          <a-tooltip>供应商邮箱<template slot="title">供应商邮箱</template></a-tooltip>
        </span>
        <a-input v-model="form.email" :maxLength="32" :placeholder="$t('请输入')+'供应商邮箱'"/>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label">
          <a-tooltip>备注<template slot="title">备注</template></a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getSupplier, addSupplier, updateSupplier} from '@/api/supplier/supplier'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        name: null,
        email:null,
        mobile: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        mobile: [{required: true, message: '供应商手机号' + this.$t('不能为空'), trigger: 'blur'}],
        email: [{required: true, message: '供应商邮箱' + this.$t('不能为空'), trigger: 'blur'}],
        name: [{required: true, message: '供应商名称' + this.$t('不能为空'), trigger: 'blur'}],

      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        email:null,
        mobile: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSupplier({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateSupplier(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addSupplier(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
